import { render, staticRenderFns } from "./tarihim.vue?vue&type=template&id=53b708f1&"
import script from "./tarihim.vue?vue&type=script&lang=js&"
export * from "./tarihim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports